import { Component, Input, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LoadingIndicatorService } from '../../../../../services/loading-indicator/loading-indicator.service';
import { EventsService } from '../../../../../services/events/events.service';
import { environment } from '../../../../../../environments/environment';

@Component({
  selector: 'tripmakery-destination-info-add-image',
  templateUrl: './destination-info-add-image.component.html',
})
export class DestinationInfoAddImageComponent implements OnInit {
  uploadStatus: string | null = null;

  public environment_;
  public isLoading: boolean = false;


  selectedFiles: { [key: string]: File | null } = {};

  public imageList = [
    {
      'identifier': 'imageJpg',
      'resolution': 'max',
      'fileType': 'jpg',
      'fileName': null,
    },
    {
      'identifier': 'imageWebp',
      'resolution': 'max',
      'fileType': 'webp',
      'fileName': null,
    },
    {
      'identifier': 'image320x180Jpg',
      'resolution': '320x180',
      'fileType': 'jpg',
      'fileName': null,
    },
    {
      'identifier': 'image320x180Webp',
      'resolution': '320x180',
      'fileType': 'webp',
      'fileName': null,
    },
    {
      'identifier': 'image320x250Jpg',
      'resolution': '320x250',
      'fileType': 'jpg',
      'fileName': null,
    },
    {
      'identifier': 'image320x250Webp',
      'resolution': '320x250',
      'fileType': 'webp',
      'fileName': null,
    },
    {
      'identifier': 'image380x180Jpg',
      'resolution': '380x180',
      'fileType': 'jpg',
      'fileName': null,
    },
    {
      'identifier': 'image380x180Webp',
      'resolution': '380x180',
      'fileType': 'webp',
      'fileName': null,
    },
    {
      'identifier': 'image100wWebp',
      'resolution': '100w',
      'fileType': 'webp',
      'fileName': null,
    },
    {
      'identifier': 'image480wWebp',
      'resolution': '480w',
      'fileType': 'webp',
      'fileName': null,
    },
    {
      'identifier': 'image720wWebp',
      'resolution': '720w',
      'fileType': 'webp',
      'fileName': null,
    },
    {
      'identifier': 'image960wWebp',
      'resolution': '960w',
      'fileType': 'webp',
      'fileName': null,
    }
  ];

  @Input() destination;

  constructor(private http: HttpClient,
              private loadingIndicatorService: LoadingIndicatorService,
              private eventsService: EventsService,
  ) {

    this.environment_ = environment;
  }

  public ngOnInit() {
    for (const image of this.imageList) {
      if (this.destination.imageDetails[image.identifier] == null) {
        continue;
      }

      image.fileName = environment.urls.blobDestinations + '/' + this.destination.slugsCountryName.de + '/' + this.destination.imageDetails[image.identifier];
    }
  }

  public showLoading() {
    this.isLoading = true;
    this.loadingIndicatorService.showLoadingBar();
  }

  public hideLoading() {
    this.isLoading = false;
    this.loadingIndicatorService.hideLoadingBar();
  }

  onFileSelected(event: Event, fieldId: string): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFiles[fieldId] = input.files[0];
      console.log(`Datei für ${fieldId}:`, this.selectedFiles[fieldId]);
    }
  }

  uploadFiles(): void {
    const formData = new FormData();

    for (const fieldId in this.selectedFiles) {
      if (this.selectedFiles.hasOwnProperty(fieldId) === false) {
        continue;
      }

      formData.append(fieldId, this.selectedFiles[fieldId]);
    }

    this.uploadStatus = 'Upload läuft...';

    let headers = new HttpHeaders();
    headers.delete('Content-Type');

    this.http.post(environment.urls.service + '/api/v1/authenticated/admin/pages/destinations/' + this.destination._id + '/images', formData, {headers: headers})
      .subscribe((response: any) => {
          this.destination = response.pageDestination; // TODO potentiell fehlerbehaftet, muss ggf. über Event aktualisiert werden
          this.loadingIndicatorService.hideLoadingBar();
        },
        error => {
          if (error.error === 'Unauthorized') {
          }
          console.log('Error', error);
          this.loadingIndicatorService.hideLoadingBar();
          this.eventsService.broadcast('requestShowErrorMessage', JSON.stringify(error));
        }
      );
  }
}
